import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { authService } from "../services/api";
import EmployeePayrollSummary from "./payroll/EmployeePayrollSummary";
import {
  EmployeePayslipsPanel,
  EmployeeForm16Panel,
} from "./payroll/EmployeePayrollDocsPanels";
import EmployeeFlexiReimbursementPanel from "./payroll/EmployeeFlexiReimbursementPanel";

const TABS = [
  { id: "summary", label: "My Payroll Summary" },
  { id: "payslips", label: "Payslips" },
  { id: "reimbursement", label: "Reimbursement" },
  { id: "form16", label: "Form-16" },
];

function resolveTab(raw) {
  const key = String(raw || "")
    .toLowerCase()
    .replace(/\s+/g, "-");
  if (key === "payslips" || key === "payslip") return "payslips";
  if (key === "reimbursement" || key === "flexi" || key === "flexi-benefits") return "reimbursement";
  if (key === "form16" || key === "form-16" || key === "form_16") return "form16";
  if (
    key === "summary" ||
    key === "my-payroll-summary" ||
    key === "investment-declaration"
  ) {
    return "summary";
  }
  return "summary";
}

/**
 * Employee → Payroll hub.
 * Tax Planning / investment declaration is via Requests (right panel), not duplicated here.
 * Reimbursement raise (opt-in / claim) is via Quick Panel; this tab is the hub.
 */
export default function EmployeePayroll() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(() =>
    resolveTab(searchParams.get("tab"))
  );
  const [employeeId, setEmployeeId] = useState(null);
  const reimbMode = (() => {
    const m = String(searchParams.get("mode") || "hub").toLowerCase();
    return m === "declare" || m === "claim" ? m : "hub";
  })();

  useEffect(() => {
    const fromUrl = resolveTab(searchParams.get("tab"));
    setActiveTab(fromUrl);
  }, [searchParams]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const userRes = await authService.getCurrentUser();
        const id = userRes?.data?.employeeId ?? userRes?.employeeId ?? null;
        if (!cancelled) setEmployeeId(id);
      } catch {
        if (!cancelled) setEmployeeId(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const selectTab = (id) => {
    setActiveTab(id);
    setSearchParams(id === "summary" ? {} : { tab: id }, { replace: true });
  };

    return (
    <div className="p-6">
      <div className="mx-auto max-w-8xl overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-md">
        <div className="border-b border-amber-100 bg-gradient-to-r from-amber-50/90 via-white to-white px-4 py-4 sm:px-6">
          <h2 className="text-lg font-semibold text-amber-950">Payroll</h2>
          <p className="mt-0.5 text-sm text-slate-600">
            Emoluments, statutory, payslips, and Form-16. Opt-in / claims from{" "}
            <span className="font-medium text-slate-800">Quick Panel → Opt-in / Claim</span>.
          </p>
        </div>

        <div className="flex flex-wrap gap-1 border-b border-slate-200 bg-white px-2 pt-2 sm:px-4">
          {TABS.map((tab) => {
            const active = activeTab === tab.id;
                        return (
                        <button
                key={tab.id}
                          type="button"
                onClick={() => selectTab(tab.id)}
                className={`rounded-t-lg border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
                  active
                    ? "border-amber-600 bg-amber-50/80 text-amber-950"
                    : "border-transparent text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                }`}
              >
                {tab.label}
          </button>
            );
          })}
                        </div>

        <div className="bg-[linear-gradient(180deg,#fffbeb22_0%,#ffffff_120px)] p-4 sm:p-6">
          {activeTab === "summary" && (
            <EmployeePayrollSummary employeeId={employeeId} />
          )}
          {activeTab === "payslips" && <EmployeePayslipsPanel />}
          {activeTab === "reimbursement" && (
            <EmployeeFlexiReimbursementPanel employeeId={employeeId} mode={reimbMode} />
          )}
          {activeTab === "form16" && <EmployeeForm16Panel />}
        </div>
      </div>
    </div>
  );
}
